import React from 'react';
import { connect } from 'react-redux';
import ViewLoading from 'components/view/loading';
import View from 'components/view';
import CollectionPage from 'components/collection/collection';
import AppIcon from 'components/apps/icon';
import { stripTags } from 'utils/string';
import actions from 'actions';
import BuildAppsCallout from 'components/apps/callout-build-apps';
import InstalledAppStatus from 'components/apps/installed-status';
import AsyncAppStatus from 'components/apps/async-status';
import CollectionEmpty from 'components/collection/empty';
import { getAppTypeLabel } from 'utils/app';
import { APP_TYPES } from 'constants/app';
import 'components/apps/apps.scss';

const fields = {
  name: {
    width: '5%',
    className: 'nowrap',
    func: ({ app, active }) => {
      const appNameDesc = (
        <>
          <span className="collection-table-images">
            <span className="image">
              <AppIcon app={app} size={48} disabled={active === false} />
            </span>
          </span>
          {app.description?.length > 0 ? (
            <div className="collection-row-description-hover-container">
              <div className="collection-row-description-hover-title">
                <b>{app.name}</b>
              </div>
              <div
                className="muted collection-row-description-hover-body"
                dangerouslySetInnerHTML={{
                  __html: stripTags(app.description),
                }}
              />
            </div>
          ) : (
            <b>{app.name}</b>
          )}
        </>
      );

      return app.description?.length > 0 ? (
        <div className="collection-row-description-hover">{appNameDesc}</div>
      ) : (
        appNameDesc
      );
    },
  },
  version: {
    className: 'nowrap',
    func: (installedApp) => {
      const { version, app } = installedApp;

      return (
        <span className="apps-list-status">
          <b>{version || app.version}</b>
          <AsyncAppStatus installedApp={installedApp} />
        </span>
      );
    },
  },
  status: {
    className: 'nowrap',
    align: 'right',
    func: (installedApp) => {
      return (
        <span className="apps-list-status">
          <InstalledAppStatus installedApp={installedApp} />
        </span>
      );
    },
  },
};

const mapStateToProps = (state) => ({
  //
});

const mapDispatchToProps = (dispatch) => ({
  fetchInstalledApps: () => {
    return dispatch(actions.client.fetchInstalledApps());
  },
});

export class Apps extends React.PureComponent {
  state = {
    loaded: false,
    installedApps: null,
  };

  componentWillMount() {
    const { fetchInstalledApps } = this.props;
    fetchInstalledApps().then((installedApps) => {
      this.setState({ loaded: true, installedApps });
    });
  }

  render() {
    const {
      location: {
        query: { tab },
      },
    } = this.props;
    const { installedApps } = this.state;

    if (!this.state.loaded) {
      return <ViewLoading />;
    }

    const { enabledApps, disabledApps } = installedApps.results
      // Filter out themes
      .filter(({ app }) => app && (app.type !== 'theme' || tab === 'theme'))
      // Filter by tab
      .filter(({ app }) => !tab || app.type === tab)
      .reduce(
        (acc, installedApp) => {
          const { app, active } = installedApp;

          if (!app) {
            return acc;
          } else if (active !== false) {
            acc.enabledApps.push(installedApp);
          } else {
            acc.disabledApps.push(installedApp);
          }

          return acc;
        },
        { enabledApps: [], disabledApps: [] },
      );

    const hasAnyApps = installedApps.results.length > 0;
    const hasListedApps = enabledApps.length > 0 || disabledApps.length > 0;

    return (
      <div className="apps-list">
        <View
          detail={true}
          headerTitle="Apps"
          headerSubtitle="Install and manage apps to enhance your store"
          uri="/apps"
          tabs={
            hasAnyApps && {
              default: {
                label: 'All',
              },
              ...APP_TYPES.filter((type) => type.id !== 'theme').reduce(
                (acc, type) => {
                  if (
                    installedApps.results.some(
                      ({ app }) => app?.type === type.id,
                    )
                  ) {
                    acc[type.id] = {
                      label: getAppTypeLabel(type.id),
                    };
                  }
                  return acc;
                },
                {},
              ),
            }
          }
        >
          {enabledApps.length > 0 && (
            <CollectionPage
              {...this.props}
              recordUri="/apps/{app_id}"
              searchable={false}
              headless={true}
              collection={{ count: enabledApps.length, results: enabledApps }}
              fields={fields}
            />
          )}
          {disabledApps.length > 0 && (
            <CollectionPage
              {...this.props}
              recordUri="/apps/{app_id}"
              searchable={false}
              headless={true}
              collection={{
                count: disabledApps.length,
                results: disabledApps,
              }}
              fields={fields}
            />
          )}
          {!hasAnyApps ? (
            <CollectionEmpty
              emptyTitle="Get started with Swell Apps"
              emptyDescription="Apps are developed and installed privately during the beta period. Read the docs below or join our community for more details."
              emptyAction={false}
            />
          ) : (
            !hasListedApps && (
              <CollectionEmpty
                emptyTitle={`No ${tab || ''} apps yet`}
                emptyDescription={`There are no apps installed${
                  tab ? 'in this category' : ''
                }.`}
                emptyAction={false}
              />
            )
          )}
          <BuildAppsCallout />
        </View>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Apps);
